import { LOCAL_STORAGE_THEME_MODE_KEY } from '../constants/constants';
import { setCssVariablesOnDocument } from '../utils/setCssVariablesOnDocument';
import { setIsDarkThemeFromThemeMode } from '../mutators/setIsDarkThemeFromThemeMode';
import { setItem } from 'owa-local-storage';
import { setThemeColorOnDocument } from '../utils/setThemeColorOnDocument';
import { setThemeMode } from '../mutators/setThemeMode';
import type { ThemeMode } from '../schema/ThemeMode';

/**
 * Updates theme info in the store and set the css variables on the document
 */
export const loadTheme = (themeMode: ThemeMode): void => {
    // Set themeMode in store and local storage
    setThemeMode(themeMode);
    setIsDarkThemeFromThemeMode(themeMode);
    setItem(self, LOCAL_STORAGE_THEME_MODE_KEY, themeMode.toString());

    setCssVariablesOnDocument();
    setThemeColorOnDocument();
};
